import axios from 'axios'
import config from '../config'

const Notice = {
    state: {
        noticeList: [],
        noticeDetail: [],
        error: false,
        msg: ''
    },
    mutations: {
      NoticeList: (state, noticeList) => state.noticeList = noticeList,
      NoticeDetail: (state, noticeDetail) => state.noticeDetail = noticeDetail,
      ERROR: (state, error) => state.error = error,
      MSG: (state, msg) => state.msg = msg
    },
    actions: {
      async  fetchNoticeList({commit}, data){
          await  axios({
                method:'post',
                url: config.LOAD_NOTICE_LIST,
                data: data
            })
            .then((result) => {
                
                commit('NoticeList', result.data.notices)
            }).catch((err) => {
                console.log(err);
            });
        },
     async fetchNoticeDetail({commit}, data){
         await axios({
             method:'post',
             url: config.LOAD_NOTICE_DETAIL,
             data: data
         })
         .then((result) => {
             commit('NoticeDetail', result.data.notice)
         }).catch((err) => {
             console.log(err);
         });
     },
     async addNotice({commit}, data){
         await axios({
             method:'post',
             url: config.ADD_NOTICE,
             data: data
         })
         .then((result) => {
             commit('ERROR', result.data.error)
             commit('MSG', result.data.msg )
         }).catch((err) => {
             console.log(err);
         });
     },
     async updateNotice({commit}, data){
         await axios({
             method:'post',
             url: config.NOTICE_UPDATE,
             data: data
         })
         .then((result) => {
             commit('ERROR', result.data.error)
             commit('MSG', result.data.msg)
         }).catch((err) => {
             console.log(err);
         });
     },
     async updateNoticeStatus({commit}, data){
         await axios({
             method:'post',
             url: config.NOTICE_UPDATE_STATUS,
             data: data
         })
         .then((result) => {
             commit('ERROR', result.data.error)
             commit('MSG', result.data.msg)
         }).catch((err) => {
             console.log(err)
         });
      },
      async deleteNotice({commit}, data){
          await axios({
              method:'delete',
              url: config.DELETE_NOTICE,
              data: data
          })
          .then((result) => {
              commit('ERROR', result.data.error)
              commit('MSG', result.data.msg)
          }).catch((err) => {
              console.log(err);
          });
      }      
    },
    getters: {
        getNoticeList: state => state.noticeList,
        getNoticeDetail: state => state.noticeDetail,
        getNoticeError: state => state.error,
        getNoticeMsg: state => state.msg
    },
}

export default Notice;